class filterId {
    constructor(
        grupos,
        estado,
        atributos,
        empleados,
        horarios,
        modelos,
    
    ) {
        
        if (grupos) {
            this.items = grupos
            this.type = 'Grupos'
        } else if (atributos) {
            this.items = atributos
            this.type='Atributos'
        } else if (modelos) {
            this.items = modelos
            this.type="Modelos"
        } else if (horarios) {
            this.items = horarios
            this.type="Horarios"
        } else {
            this.items = empleados
            this.type="Empleados"
        }

        this.grupos = grupos
        this.estado = estado
        this.atributos= atributos
        this.empleados=empleados
        this.horarios=horarios
        this.modelos = modelos
        
    }
    static fromJson({
        Grupos,
        Estado,
        Atributos,
        Empleados,
        Horarios,
        Modelos,
        GruposId,
        
       

    }){
        return new filterId(
        Grupos,
        Estado,
        Atributos,
        Empleados,
        Horarios,
        Modelos,
        GruposId

            
        )
    }

    }
    export default filterId